import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useToast } from '@/hooks/use-toast';

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading) {
      if (user) {
        // User is authenticated
        toast({
          title: 'Authentication successful',
          description: 'You have been successfully logged in.',
        });
        navigate('/dashboard');
      } else {
        // User is not authenticated
        toast({
          title: 'Authentication error',
          description: 'Please log in to continue.',
          variant: 'destructive',
        });
        navigate('/login');
      }
    }
  }, [user, loading, navigate, toast]);

  return null;
}; 